export default __webpack_public_path__ + "static/media/right-arrow.c50d9a18.svg";